"use client";

import { useEffect, useState } from "react";

export default function PipelineAnimationIframe() {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 64rem)");
    setIsDesktop(mq.matches);
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  if (!isDesktop) return null;

  return (
    <iframe
      src="/animations/pipeline.html"
      className="w-full h-full"
      style={{ border: "none", display: "block", background: "transparent" }}
      title="Pipeline animation"
      allowTransparency
    />
  );
}
